import styled from "styled-components";

export const Form = styled.form`
  border-radius: 4px;
  padding: 32px;

  width: 100%;
  max-width: 352px;
  min-height: 340px;

  @media (min-width: 1920px) {
    padding: 32px;
  }
`;

export const Container = styled.div`
  align-items: center;
  margin-bottom: 40px;
`;

export const ErrorMessage = styled.p`
  color: var(--color-red);
`;
